import dynamic from 'next/dynamic';
import { NewProductProps } from './types';
import { cleanOffersVariants } from './v2/Variants/helpers';

const NewProduct = dynamic(
  () => import('@/components/collections/[handle]/NewProductPage'),
  {
    ssr: true,
  },
);

const NewProductV2 = dynamic(
  () => import('@/components/collections/[handle]/NewProductPage/v2'),
  {
    ssr: true,
  },
);

const NewProductPageLayout = (props: NewProductProps) => {
  const { offers, rVariants = [] } = props;

  // Heavy lifting Backend-in-the-frontend
  // Process and clean the offers by adding necessary rVariants
  const cleanOffers = cleanOffersVariants({
    offers,
    rVariants,
  });

  // Determine whether to use rVariants based on the number of clean offers
  // cleanOffers.length should be equal to offers.length
  const shouldUseRVariants = cleanOffers.length === offers.length;

  if (shouldUseRVariants) {
    return (
      <NewProductV2
        {...{
          ...props,
          offers: cleanOffers,
        }}
        key={props.handle}
      />
    );
  }

  // Default case: Do not use rVariants and render the original product component
  return <NewProduct {...props} key={props.handle} />;
};

export default NewProductPageLayout;
